import { loadEnv } from "@smart/bridge-env-dom";
import { prettyJsonStringify } from "@smart/itops-utils-basic";

import { Contact, CreateContactRequest } from "../types";

export const buildGetRelatedContacts =
  (getContact: (id: string) => Promise<Contact>) =>
  async (contacts: Contact[]) => {
    // This can be group of people or company member or trust contact ids
    const relatedContactIds = contacts.filter(Boolean).flatMap(
      /**
       * groupOfPeople.people in smokeball version 8.6 is { id: string }[]
       * and it changes to string[] in version 8.8
       * The check should be removed once all clients have upgraded to 8.8
       */
      (c) =>
        (c.groupOfPeople?.people?.map((p: any) =>
          typeof p === "string" ? p : p.id,
        ) as string[]) || [
          ...(c.company?.staff ?? c.company?.staffIds ?? []),
          ...(c.company?.directors ?? c.company?.directorIds ?? []),
          ...(c.trust?.contacts ?? c.trust?.contactIds ?? []),
        ],
    );
    const relatedContacts =
      relatedContactIds.length > 0
        ? await Promise.all(relatedContactIds.map((id) => getContact(id)))
        : [];
    return [...contacts, ...relatedContacts].filter((c) => c && !c.isDeleted);
  };

export const validateTrustContact = (
  trust?: CreateContactRequest["trust"],
): void => {
  if (trust && Object.keys(trust).length > 0 && loadEnv("Region") !== "nova") {
    throw new Error(
      `Trust contacts are only supported in the US region. Trust: ${prettyJsonStringify(trust)}`,
    );
  }
};
